export default __webpack_public_path__ + "static/media/Path3477.999897c5.svg";